import { PULSE_CONSENT_COOKIE_NAME, readCookie } from '../consent.js';

/**
 * Whether the consent cookie is the literal `true` — Cineamo's own banner cookie
 * (`__analysis_cookies_opt_in`) unless `config.consentCookieName` names another.
 */
export function readCookieConsent(cookieName: string = PULSE_CONSENT_COOKIE_NAME): boolean {
    if (typeof document === 'undefined') return false;

    // `readCookie` rather than a third hand-rolled parse: only `tracker.ts` is barred from value
    // imports of `consent.js`, because the install-free CI step cannot resolve one there.
    return readCookie(document.cookie, cookieName) === 'true';
}
